// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //Das sind die DEV Daten
  firebase: {
    apiKey: "AIzaSyCxcVnP8-OXbM2J8u0nhtwhPDXHrjMl3ks",
    authDomain: "streber-42-dev.firebaseapp.com",
    //databaseURL: "https://streber-42-dev.firebaseio.com",
    projectId: "streber-42-dev",
    storageBucket: "streber-42-dev.appspot.com",
    messagingSenderId: "354582528976",
    appId: "1:354582528976:web:1723a7cad49750410c6fd5",
    measurementId: "G-RN6XZR0GN9"
  }
  // das sind die LIVE Daten
  // firebase: {
  //   apiKey: "AIzaSyB11JWdsq-MVZNw5sz5n_4P6cPI74OHFR0",
  //   authDomain: "streber-42.firebaseapp.com",
  //   databaseURL: "https://streber-42.firebaseio.com",
  //   projectId: "streber-42",
  //   storageBucket: "streber-42.appspot.com",
  //   messagingSenderId: "713442753493",
  //   appId: "1:713442753493:web:16c6912157383f05045b5c",
  //   measurementId: "G-QK3HFLX758"
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
